
<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <div style="float: right">
            <OfSearch
              @search="search"
              style="float: left; padding-right: 5%"
              :placeholder="placeholder"
            ></OfSearch>
            <el-button type="danger" @click="loadData">查询</el-button>
          </div>
        </el-row>
      </div>

      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="sickGrantModel"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
        <el-table-column
            prop="Id"
            label="编号"
            width="200"
            sortable
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="CapitalId"
            label="资金支出明细编号"
            width="200"
            sortable
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Amount"
            label="资助金额"
            width="115"
            sortable
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Source"
            label="资金来源"
            width="115"
            sortable
            :formatter="showSource"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="CreateTime"
            label="资助时间"
            width="115"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              {{ (scope.row.CreateTime * 1000) | formatDate2 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="Describe"
            label="资助明细"
            sortable
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:read
                @click="query(scope.row)"
                type="text"
                size="mini"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="searchModel.pageSize"
            :currentPage="searchModel.currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
        <ModelQuery v-if="showQuery" :dataForm="queryModel" @formCallBack="formCallBack">

        </ModelQuery>
      </div>
    </BasePage>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import ModelQuery from "@/modules/zjrc/pages/rescue/sickgrant/query";
import api from "@/modules/zjrc/api";

export default {
  props: {},
  data() {
    return {
      headerRow: "headerRow",
      sickGrantModel: [], //表格数组
      isloading: false,
      width: "70%",
      searchModel: { ApplyId: "", currentPage: 1, PageSize: 15, SearchKey: "" },
      placeholder: "请输入编号",
      applyId: "", //申请Id
      total:0,//总行数
      showQuery:false,
      queryModel:{}
    };
  },
  components: {
    OfDialog,
    OfSearch,
    BasePage,
    OfPagination,
    ModelQuery
  },
  mounted() {
    let that = this;
    that.applyId = that.$route.query.Id;
    that.loadData();
  },
  methods: {
    loadData() {
      let that = this;
      that.isloading = true;
      let params = {
        ApplyId: that.applyId,
        PageIndex: that.searchModel.currentPage,
        PageSize: that.searchModel.PageSize,
      };
      api.QuerySickGrantByApplyId(params).then((res) => {
        if (res.data.Code == 0) {
          that.sickGrantModel = res.data.Data.rows;
          that.total=res.data.Data.total;
        }
        that.isloading = false;
      });
    },
    //关键字搜索
    search(searchKey) {
      let that = this;
      that.searchModel.SearchKey = searchKey;
      this.loadData();
    },
    //详情
    query(rowData){
      let that=this;
      that.queryModel=rowData;
      that.showQuery=true;
    },
    formCallBack(){
      let that=this;
      that.showQuery=false;
    },
    //展示资金来源
    showSource(rowData){
      switch (rowData.Source) {
          case 0:
            return "社会捐赠";
          case 1:
            return "财政拨款";
          case 2:
            return "其他";
        }
    },
    //列表高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
    //改变分页大小
    handleSizeChange(val) {
      let that = this;
      that.searchModel.currentPage = 1;
      that.searchModel.pageSize = val;
      that.loadData();
    },
    //改变当前页码
    handleCurrentChange(val) {
      if (that.total > that.searchModel.pageSize) {
        that.searchModel.currentPage = val;
        that.loadData();
      }
    },
  },
};
</script>

<style>
.hideButton .dialog-footer >>> .el-button--primary {
  display: none;
}
</style>
